import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import Spacer from 'components/Spacer'
import Button from 'components/Button'
import Row from 'components/Row'
import { get } from 'service/api'

import Container from './styles'

export default function Terms() {
  const { t } = useTranslation()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [terms, setTerms] = useState('')

  useEffect(() => {
    let mounted = true
    const find = async () => {
      setLoading(true)
      let res = await get({ url: '/terms' })
      if (mounted && res) {
        setLoading(false)
        setTerms(res)
      }
    }
    find()

    return () => (mounted = false)
  }, [])

  function handleBack() {
    history.goBack()
  }

  return (
    <Container>
      <Spacer height={30} />
      <h1>{t('terms.title')}</h1>
      <Spacer height={20} />
      <div>
        {!loading && terms && (
          <div className="markdown-body">
            <ReactMarkdown children={terms} remarkPlugins={[remarkGfm]} />
          </div>
        )}
      </div>
      <Spacer height={30} />
      <Row justify="center">
        <Button
          onClick={handleBack}
          className="primary"
          label={t('button.back')}
        />
      </Row>
      <Spacer height={30} />
    </Container>
  )
}
